$(function() {
	$('[data-toggle="popover"]').popover({
		container: 'body'
	});
	$('[data-toggle="tooltip"]').tooltip();

	/* Photo gallery */
	$('div.trip-page div.photo-gallery').mouseover(function (e) {
		if (!$(this).hasClass('show-controls')) {
			$(this).find('span.arrow-left').animateCss('fadeInRight');
			$(this).find('span.arrow-right').animateCss('fadeInLeft');
		}

		$(this).addClass('show-controls');
	}).mouseleave(function () {
		$(this).removeClass('show-controls');
	});

	$('div.trip-page div.photo-gallery span[class^=arrow-]').click(function () {
		var gallery = $(this).parents('div.photo-gallery');
		var _scrollLeft = gallery.find('ul.photos').scrollLeft();
		var itemWidth = gallery.find('ul.photos').children('li').first().width();

		if ((_scrollLeft === 0 && $(this).hasClass('arrow-left')) || (_scrollLeft === gallery.find('ul.photos')[0].scrollWidth - gallery.find('ul.photos').width() && $(this).hasClass('arrow-right'))) {
			$(this).animateCss('shake');
			return false;
		}
		var summand = $(this).hasClass('arrow-left') ? -itemWidth : itemWidth;
		gallery.find('ul.photos').stop().animate({
			'scrollLeft' : (_scrollLeft + summand) + 'px'
		});
	});

	// Move indicator
	$('div.trip-page div.photo-gallery ul.photos').scroll(function() {
		var indicator = $(this).next('span.indicator').children('span');
		var contentWidth = $(this)[0].scrollWidth;
		var viewWidth = $(this).width();
		var leftSpace = $(this).scrollLeft();
		var factor = leftSpace / (contentWidth - viewWidth);
		var maxLeft = indicator.parent().width() - indicator.width() - 2;

		indicator.stop().animate({
			left: maxLeft * factor
		}, 0);
	});

	// Swipe gestures
	$('div.trip-page div.photo-gallery ul.photos').on('swipeleft', function() {
		$('div.trip-page div.photo-gallery span.arrow-right').trigger('click');
	});
	$('div.trip-page div.photo-gallery ul.photos').on('swiperight', function() {
		$('div.trip-page div.photo-gallery span.arrow-left').trigger('click');
	});

	/* Tabs nav */
	/*
	var tabsNavActiveArrow = $('nav.tabs-nav svg.active-arrow');
	function setTripPageNavArrow() {
		if ($('nav.tabs-nav a.nav-link.active').length > 0) {
			var left = $('nav.tabs-nav a.nav-link.active').offset().left + ($('nav.tabs-nav a.nav-link.active').width() / 2);
			tabsNavActiveArrow.css('left', left + 'px').show();
		}
	}
	setTripPageNavArrow();

	$('nav.tabs-nav a.nav-link').mouseover(function() {
		var left = $(this).offset().left + ($(this).width() / 2);
		tabsNavActiveArrow.stop().animate({ 'left' : left + 'px' }, 300);
	});

	$('nav.tabs-nav').mouseleave(function() {
		var left = $('nav.tabs-nav a.nav-link.active').offset().left + ($('nav.tabs-nav a.nav-link.active').width() / 2);
		tabsNavActiveArrow.stop().animate({ 'left' : left + 'px' }, 300);
	});

	$('nav.tabs-nav a.nav-link').click(function() {
		var target = $(this).attr('href').replace('#', '');
		$(this).parents('nav.tabs-nav').attr('class', 'tabs-nav ' + target);
	});
	if ($('nav.tabs-nav').length > 0) $('nav.tabs-nav').attr('class', 'tabs-nav ' + $('nav.tabs-nav a.nav-link.active').attr('href').replace('#', ''));
	*/

	//Services
	$('div.trip-page div.services div.show-more a.link').click(function() {
		$('div.trip-page div.services').toggleClass('show');
	});

	/* Booking case */
	//Dates prices (Button)
	/*
	$('div.booking-case button[type=button]').click(function() {
		$('a[href=\'#dates-prices\']').tab('show');
		$('html, body').stop().animate({
			scrollTop: $('nav.tabs-nav').offset().top
		}, 1000);
		$('nav.tabs-nav').attr('class', 'tabs-nav dates-prices');
		window.location.href = '#dates-prices';
		setTripPageNavArrow();
	});
	*/

	/* Side modal */
	//Accommodation Details
	/* Photo gallery */
	$('div.side-modal div.accommodation-details div.photos').mouseover(function (e) {
		if (!$(this).hasClass('show-controls')) {
			$(this).find('span.arrow-left').animateCss('fadeInRight');
			$(this).find('span.arrow-right').animateCss('fadeInLeft');
		}

		$(this).addClass('show-controls');
	}).mouseleave(function () {
		$(this).removeClass('show-controls');
	});

	$('div.side-modal div.accommodation-details div.photos span[class^=arrow-]').click(function () {
		var gallery = $(this).parents('div.photos');
		var _scrollLeft = gallery.find('ul.photos').scrollLeft();

		if ((_scrollLeft === 0 && $(this).hasClass('arrow-left')) || (_scrollLeft === gallery.find('ul.photos')[0].scrollWidth - gallery.find('ul.photos').width() && $(this).hasClass('arrow-right'))) {
			$(this).animateCss('shake');
			return false;
		}
		var summand = $(this).hasClass('arrow-left') ? -600 : 600;
		gallery.find('ul.photos').stop().animate({
			'scrollLeft' : (_scrollLeft + summand) + 'px'
		});
	});

	$('div.booking-case.products ul.list-group > li').click(function() {
		$(this).find('input[type=radio]').prop('checked', true);
	});

	// Toggle content
	$('button.toggle-content').click(function() {
		$('div.raw-content').toggleClass('show');
		$(this).toggleClass('show');
	});

	// Rotate promo display
	function rotateCountdown(duration) {
		setTimeout(function () {
			if ($('div.promo-display > span:not(.active)').length > 0) {
				var active = $('div.promo-display > span.active');
				var notActive = $('div.promo-display > span:not(.active)');

				notActive.addClass('active');
				active.removeClass('active');
			}

			rotateCountdown(duration);
		}, duration);
	}
	rotateCountdown(3000);
});
